import { createApp } from 'vue'
import store from './store';
import App from './App.vue'

require('@/assets/stylesheets/bulma.min.css');
require('@/assets/stylesheets/bulma-switch.css');
require('@/assets/stylesheets/tooltip.css');
require('@/assets/stylesheets/fonts.css');

createApp(App).use(store).mount('#app');